import { Skeleton } from "@mui/material";

import * as SubframeCore from "@subframe/core";
import { Badge } from "subframe/components/Badge";

import {
  HISTORY_TYPE,
  RECOGNITION_CATEGORY,
} from "modules/Retention/constants/constants";
import { renderSentimentBadgeWithScore } from "modules/Retention/utils/sentiment";

import { getRelativeDate } from "utils/date";
import { isEmpty as isArrayEmpty } from "utils/array";

import EmptyState from "../EmptyState";
import SentimentBreakdown from "../SentimentBreakdown";
import HistorySurveyAccordion from "../HistorySurveyAccordion";

const History = ({ isLoading = false, employeeHistory = [], employeeId }) => {
  return (
    <div className="w-full flex-col gap-4 items-start flex">
      <span className="text-default-font text-subheader font-subheader">
        History
      </span>
      {isLoading ? (
        <div className="w-full">
          <Skeleton variant="rounded" width="100%" height="500px" />
        </div>
      ) : (
        <div className="w-full flex-col-reverse	items-start flex">
          {isArrayEmpty(employeeHistory) ? (
            <EmptyState
              icon=<SubframeCore.Icon
                className="text-[44px] font-[100] leading-[44px] text-neutral-400"
                name="FeatherAlertCircle"
              />
              primaryText="Something went wrong."
              secondaryText="Hm. There should be data here.
            "
            />
          ) : (
            employeeHistory.map((history, index) => {
              return (
                <div className="w-full gap-4 pr-2 pl-2 items-start flex">
                  <div className="h-full flex-col items-center flex">
                    <div
                      className={`flex-none h-7 w-7 rounded-full gap-2 items-center justify-center flex ${
                        HISTORY_TYPE[history?.type]?.background
                      }`}
                    >
                      {HISTORY_TYPE[history?.type]?.icon}
                    </div>
                    {index !== 0 && (
                      <div className="grow shrink-0 basis-0 h-full w-px flex-col gap-2 items-center flex bg-neutral-200" />
                    )}
                  </div>

                  <div className="grow shrink-0 basis-0 w-full flex-col gap-1 pt-1 pb-6 items-start flex">
                    <div className="w-full gap-1 flex-wrap items-start flex flex-col">
                      <span className="text-subtext-color text-label font-label first-letter:uppercase">
                        {getRelativeDate(history?.created_at)}
                      </span>
                      <div className="flex w-full items-start justify-between">
                        <span className="text-default-font text-body-bold font-body-bold">
                          {history?.title}
                        </span>
                        {history?.type ===
                          HISTORY_TYPE["SURVEY_COMPLETED"].value && (
                          <div className="shrink-0 gap-1">
                            {renderSentimentBadgeWithScore(
                              history?.data?.survey?.overall_sentiment_score,
                              history?.data?.survey_rate?.response_rate
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {history?.type !==
                    HISTORY_TYPE["SURVEY_COMPLETED"].value ? (
                      <div className="grow shrink-0 basis-0 h-full w-full flex-col gap-2 items-start flex">
                        <span className="text-default-font text-body font-body">
                          {history?.description}
                        </span>
                        {(history?.type ===
                          HISTORY_TYPE["RECOGNITION_RECEIVED"].value ||
                          history?.type ===
                            HISTORY_TYPE["RECOGNITION_SENT"].value) && (
                          <Badge variant="success">
                            {RECOGNITION_CATEGORY[history?.category]?.label}
                          </Badge>
                        )}
                      </div>
                    ) : (
                      <>
                        <div className="py-2 w-full">
                          <SentimentBreakdown
                            data={{
                              Positive:
                                history?.data?.sentiments?.positive_sentiment,
                              Neutral:
                                history?.data?.sentiments?.neutral_sentiment,
                              Negative:
                                history?.data?.sentiments?.negative_sentiment,
                            }}
                          />
                        </div>
                        <HistorySurveyAccordion
                          employeeId={employeeId}
                          surveyId={history?.id}
                          surveyRate={history?.data?.survey_rate}
                        />
                      </>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default History;
